import styled from 'styled-components';

const DateText = styled.div`
  font-size: 16px;
  color: rgba(0, 0, 0, 0.5);
`;

export default DateText;
